export default "__VITE_ASSET__uNujgo2c__";